export default {
  CAMPAIGN: "campaign",
  DATA_ENRICHMENT: "data_enrichment",
  SELECTION: "selection",
};
